import { render, staticRenderFns } from "./BootstrapComponent.vue?vue&type=template&id=1972173f&scoped=true"
import script from "./BootstrapComponent.vue?vue&type=script&lang=js"
export * from "./BootstrapComponent.vue?vue&type=script&lang=js"
import style0 from "./BootstrapComponent.vue?vue&type=style&index=0&id=1972173f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972173f",
  null
  
)

export default component.exports